export default __webpack_public_path__ + "static/cta-2-3d7eba341a1eba0db55b220bb0f23ca0.webp";